import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CareerUpdate() {
  const navigate = useNavigate();
  const { srno } = useParams();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [formData, setFormData] = useState({
    srno: "",
    name: "",
    email: "",
    mobile: "",
    whatsapp_mobile: "",
    city: "",
    hometown: "",
    college: "",
    university: "",
    passing_year: "",
    branch: "",
    linkedinid: "",
    githubid: "",
    referredby: "",
    currentcompany: "",
    yearsOfExperience: "",
    currentDesignation: "",
    noticePeriod: "",
    currentSalary: "",
    skills: "",
    dob: "",
    workLocation: "",
    typePartFull: "",
    typeFullIntern: "",
    jobType: "",
    uploadCV: "",
  });

  const [careerList, setCareerList] = useState([]);
  const callApiCareerList = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + 'career/alluser';
      const response = await axios.get(url, { headers });
      setCareerList(response.data);
    }
    catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    if (careerList.length === 0) {
      callApiCareerList();
    }
    const matchingCareer = careerList.find((item) => item.srno === parseInt(srno, 10));
    if (matchingCareer) {
      setFormData({
      ...matchingCareer,
      dob: matchingCareer.dob ? matchingCareer.dob.split('T')[0] : ""
    });
    }
  }, [srno, careerList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const callApiUpdateCareer = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + 'career/updatecareer';

      const { createdon, updatedon, ...dataToSend } = formData;
      
      const response = await axios.put(url, formData, { headers });
      console.log(response)
    } catch (err) {
      console.error(err);
      toast.error('Failed to update career.', {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const handleConfirmUpdate = async () => {
    setShowConfirmModal(false);
    await callApiUpdateCareer();
    toast.success('Career Updated Successfully', {
      position: "top-right",
      autoClose: 1000,
      theme: "colored",
    })
    setTimeout(() => {
      navigate('/career');
    }, 2000);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Update Career
          </div>
          <div className="form-card-body">
            <form onSubmit={handleSubmit}>

              {/* Row 1: Sr No & Name */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="srno" className="form-label">Sr No:</label>
                  <input type="number" name="srno" className="form-control" value={formData.srno || ""} disabled />
                </div>
                <div className="col-md-6">
                  <label htmlFor="name" className="form-label">Name:</label>
                  <input type="text" name="name" className="form-control" value={formData.name || ""} onChange={handleChange} placeholder="Name" />
                </div>
              </div>

              {/* Row 2: Email & Mobile */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="email" className="form-label">Email:</label>
                  <input type="email" name="email" className="form-control" value={formData.email || ""} onChange={handleChange} placeholder="Email" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="mobile" className="form-label">Mobile Number:</label>
                  <input type="text" name="mobile" className="form-control" value={formData.mobile || ""} onChange={handleChange} placeholder="Mobile" maxLength="10" />
                </div>
              </div>

              {/* Row 3: WhatsApp & City */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="whatsapp_mobile" className="form-label">Whatsapp Number:</label>
                  <input type="text" name="whatsapp_mobile" className="form-control" value={formData.whatsapp_mobile || ""} onChange={handleChange} placeholder="WhatsApp Mobile" maxLength="10" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="city" className="form-label">City:</label>
                  <input type="text" name="city" className="form-control" value={formData.city || ""} onChange={handleChange} placeholder="City" />
                </div>
              </div>

              {/* Row 4: Hometown & College */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="hometown" className="form-label">Hometown:</label>
                  <input type="text" name="hometown" className="form-control" value={formData.hometown || ""} onChange={handleChange} placeholder="Hometown" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="college" className="form-label">College Name:</label>
                  <input type="text" name="college" className="form-control" value={formData.college || ""} onChange={handleChange} placeholder="College" />
                </div>
              </div>

              {/* Row 5: University & Passing Year */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="university" className="form-label">University:</label>
                  <input type="text" name="university" className="form-control" value={formData.university || ""} onChange={handleChange} placeholder="University" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="passing_year" className="form-label">Passing Year:</label>
                  <input type="number" name="passing_year" className="form-control" value={formData.passing_year || ""} onChange={handleChange} placeholder="Passing Year" />
                </div>
              </div>

              {/* Row 6: Branch & LinkedIn */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="branch" className="form-label">Branch:</label>
                  <input type="text" name="branch" className="form-control" value={formData.branch || ""} onChange={handleChange} placeholder="Branch" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="linkedinid" className="form-label">LinkedIn ID (url):</label>
                  <input type="url" name="linkedinid" className="form-control" value={formData.linkedinid || ""} onChange={handleChange} placeholder="LinkedIn ID" />
                </div>
              </div>

              {/* Row 7: GitHub & Referred By */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="githubid" className="form-label">GitHub ID (url):</label>
                  <input type="url" name="githubid" className="form-control" value={formData.githubid || ""} onChange={handleChange} placeholder="GitHub ID" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="referredby" className="form-label">Reference ID:</label>
                  <input type="text" name="referredby" className="form-control" value={formData.referredby || ""} onChange={handleChange} placeholder="Referred By" />
                </div>
              </div>

              {/* Row 8: Current Company & Years of Experience */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="currentcompany" className="form-label">Current Company:</label>
                  <input type="text" name="currentcompany" className="form-control" value={formData.currentcompany || ""} onChange={handleChange} placeholder="Current Company" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="yearsOfExperience" className="form-label">Years of Experience:</label>
                  <input type="number" name="yearsOfExperience" className="form-control" value={formData.yearsOfExperience || ""} onChange={handleChange} placeholder="Years of Experience" />
                </div>
              </div>

              {/* Row 9: Current Designation & Notice Period */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="currentDesignation" className="form-label">Current Designation:</label>
                  <input type="text" name="currentDesignation" className="form-control" value={formData.currentDesignation || ""} onChange={handleChange} placeholder="Current Designation" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="noticePeriod" className="form-label">Notice Period (in days):</label>
                  <input type="number" name="noticePeriod" className="form-control" value={formData.noticePeriod || ""} onChange={handleChange} placeholder="Notice Period" />
                </div>
              </div>

              {/* Row 10: Current Salary & Skills */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="currentSalary" className="form-label">Current Salary (In lakhs):</label>
                  <input type="number" name="currentSalary" className="form-control" value={formData.currentSalary || ""} onChange={handleChange} placeholder="Current Salary" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="skills" className="form-label">Skills:</label>
                  <input type="text" name="skills" className="form-control" value={formData.skills || ""} onChange={handleChange} placeholder="Skills" />
                </div>
              </div>

              {/* Row 11: DOB & Work Location */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="dob" className="form-label">DOB:</label>
                  <input type="date" name="dob" className="form-control" value={formData.dob || ""} onChange={handleChange} placeholder="Date of Birth" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="workLocation" className="form-label">Work Location:</label>
                  <input type="text" name="workLocation" className="form-control" value={formData.workLocation || ""} onChange={handleChange} placeholder="Work Location" />
                </div>
              </div>

              {/* Row 12: Part/Full Time & Full/Intern */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="typePartFull" className="form-label">Part Time/Full Time:</label>
                  <input type="text" name="typePartFull" className="form-control" value={formData.typePartFull || ""} onChange={handleChange} placeholder="Type (Part/Full)" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="typeFullIntern" className="form-label">Full Time/Intern:</label>
                  <input type="text" name="typeFullIntern" className="form-control" value={formData.typeFullIntern || ""} onChange={handleChange} placeholder="Type (Full/Intern)" />
                </div>
              </div>

              {/* Row 13: Job Type */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="jobType" className="form-label">Job Type:</label>
                  <input type="text" name="jobType" className="form-control" value={formData.jobType || ""} onChange={handleChange} placeholder="Job Type" />
                </div>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-primary">
                  Update Career
                </button>
                <Link to="/career" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>

            </form>
          </div>
        </div>
      </div>

      {/* Update Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update this career data?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </>
  );
}

export default CareerUpdate;
